import { AccessControlClient } from "../web-api-client";

import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

const http = {
  fetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
    return fetch(url, {
      ...init,
      credentials: "include",
    });
  },
};

export const accessControlClient = new AccessControlClient(apiBaseUrl, http);
